var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var ListSection = /** @class */ (function () {
            function ListSection() {
                this.templateUrl = './app/views/directives/inputForm/listSection.html';
                this.restrict = 'E';
                this.controller = [
                    '$scope', '$rootScope', 'ModalService', 'formSectionService', 'formService', 'formDataService', 'deleteService',
                    'processService', "processDocumentService", 'gisMapService', MultiAddSectionController
                ];
                this.controllerAs = 'controller';
                this.scope = {
                    isConfigureMode: "=",
                    isEditMode: "=",
                    showSlider: "=",
                    field: "=",
                    formSection: "=",
                    process: "=",
                    isReadOnly: "=",
                    fieldBlurred: "=",
                    processConfigurationId: "=",
                    processConfiguration: "=",
                    formData: "=",
                    formDataId: "=",
                    formId: "=",
                    form: "=",
                    processId: "=",
                    step: "="
                };
            }
            ListSection.prototype.link = function ($scope, element, attrs) {
            };
            return ListSection;
        }());
        directives.ListSection = ListSection;
        var ListSectionModel = /** @class */ (function (_super) {
            __extends(ListSectionModel, _super);
            function ListSectionModel($scope, $rootScope, modalService, formSectionService, formService, formDataService, deleteService, processService, processDocumentService, gisMapService) {
                var _this = _super.call(this, $scope, modalService, formSectionService, formService, deleteService) || this;
                _this.$rootScope = $rootScope;
                _this.formDataService = formDataService;
                _this.processDocumentService = processDocumentService;
                _this.gisMapService = gisMapService;
                $scope.userActionInitiated = function (u) { return _this.userActionInitiated(u); };
                return _this;
            }
            ListSectionModel.prototype.userActionInitiated = function (userAction) {
                this.$rootScope.$broadcast('userActionInitated', userAction);
            };
            ListSectionModel.prototype.zoomToFeature = function (featureId) {
                this.gisMapService.zoomToFeature(featureId, this.$scope.process);
            };
            ListSectionModel.prototype.selectRow = function (row) {
                this.isEditing = true;
                this.editRow = row;
                this.isEditRowReadOnly = false;
                if (this.$scope.process && this.$scope.process.metadata[row.id]) {
                    try {
                        var metadataObj = JSON.parse(this.$scope.process.metadata[row.id]);
                        if (metadataObj.onlyAllowApiEdits) {
                            this.isEditRowReadOnly = true;
                        }
                    }
                    catch (error) {
                        warsApp.services.WarsLogger.logWarn("Error Parsing JSON for metadata: " + error, "ListSection");
                    }
                }
            };
            ListSectionModel.prototype.addListItem = function (formSection) {
                if (!this.$scope.formData) {
                    return;
                }
                if (this.$scope.formData[formSection.objectSchema.uniqueIdentifier] == null) {
                    this.$scope.formData[formSection.objectSchema.uniqueIdentifier] = [];
                }
                var newItem = { id: warsApp.services.UtilityService.generateGuidComb() };
                this.formDataService.addListRow(this.$scope.process.id, this.$scope.formId, this.$scope.formDataId, formSection.objectSchema.uniqueIdentifier, newItem.id);
                this.$scope.formData[formSection.objectSchema.uniqueIdentifier].push(newItem);
                this.isEditing = true;
                this.editRow = newItem;
                this.$scope.process.processNames[this.editRow.id] = null;
            };
            ListSectionModel.prototype.removeRow = function (row, formSection) {
                var _this = this;
                this.isEditing = false;
                this.formDataService.removeListRow(this.$scope.process.id, this.$scope.formId, this.$scope.formDataId, formSection.objectSchema.uniqueIdentifier, this.editRow.id).then(function (result) {
                    if (result && result.data.docIdsRemoved != null) {
                        _this.processDocumentService.updateProcessDocuments(_this.$scope.process, [], result.data.docIdsRemoved);
                    }
                    if (result && result.data.featuresRemoved != null) {
                        result.data.featuresRemoved.forEach(function (f) {
                            _this.gisMapService.removeFeature(f, _this.$scope.process);
                        });
                    }
                });
                this.$scope.formData[formSection.objectSchema.uniqueIdentifier].remove(this.editRow);
                this.editRow = null;
            };
            return ListSectionModel;
        }(directives.FieldBaseModel));
        directives.ListSectionModel = ListSectionModel;
        var MultiAddSectionController = /** @class */ (function () {
            function MultiAddSectionController($scope, $rootScope, modalService, formSectionService, formService, formDataService, deleteService, processService, processDocumentService, gisMapService) {
                var _this = this;
                this.$scope = $scope;
                this.$rootScope = $rootScope;
                this.modalService = modalService;
                this.formSectionService = formSectionService;
                this.formService = formService;
                this.processDocumentService = processDocumentService;
                this.gisMapService = gisMapService;
                $scope.model = new ListSectionModel($scope, $rootScope, modalService, formSectionService, formService, formDataService, deleteService, processService, processDocumentService, gisMapService);
                $scope.getDocumentDisplayString = function (docId) { return _this.getDocumentDisplayString(docId); };
            }
            MultiAddSectionController.prototype.getDocumentDisplayString = function (docId) {
                if (docId) {
                    var document_1 = this.processDocumentService.getDocumentById(this.$scope.process, docId);
                    if (document_1) {
                        return document_1.fileName;
                    }
                }
                return "";
            };
            return MultiAddSectionController;
        }());
        directives.MultiAddSectionController = MultiAddSectionController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('ListSection', []);
